// DS: DS6.1 - Link semantics
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import React from 'react';
import omit from 'lodash/omit';
import PlainButtonOrLink from '../../../../Buttons/PlainButtonOrLink';
import { setRef } from '../../../../../utils/refHelpers';
import { useListItem } from '../../common';
import ListItemContent from '../../legos/ListItemContent';
const ListItemLink = (unfilteredProps)=>{
    const { rootProps, contentProps, ref } = useListItem(_object_spread_props(_object_spread({}, unfilteredProps), {
        withStrongHoverEffect: true
    }));
    return /*#__PURE__*/ React.createElement(PlainButtonOrLink, _object_spread({
        innerRef: (node)=>setRef(ref, node)
    }, omit(rootProps, [
        'disabled',
        'checked',
        'withStrongHoverEffect'
    ])), /*#__PURE__*/ React.createElement(ListItemContent, contentProps));
};
ListItemLink.displayName = 'ListItemLink';
export default ListItemLink;

//# sourceMappingURL=ListItemLink.js.map